import {
  ApplicationRef,
  createComponent,
  ElementRef,
  inject,
  Injectable,
  Signal,
  Type,
} from '@angular/core';
import { ModalDialogComponent } from './modal-dialog.component';
import { take } from 'rxjs/operators';

export interface AttachableModalDialog {
  modalDialog: ModalDialogComponent | Signal<ModalDialogComponent>;
}

@Injectable({ providedIn: 'root' })
export class ModalDialogService {
  readonly appRef = inject(ApplicationRef);

  attachDialog<T extends AttachableModalDialog>(dialogComponentClass: Type<T>) {
    const rootComponent = this.appRef.components[0];
    const dialogWrapper = window.document.createElement('DIV');

    dialogWrapper.style.display = 'none';

    rootComponent.injector
      .get(ElementRef)
      .nativeElement.insertAdjacentElement('afterend', dialogWrapper);

    const dialogComponent = createComponent(dialogComponentClass, {
      hostElement: dialogWrapper,
      environmentInjector: this.appRef.injector,
    });

    this.appRef.attachView(dialogComponent.hostView);

    dialogComponent.changeDetectorRef.detectChanges();

    const modalDialog =
      typeof dialogComponent.instance.modalDialog === 'function'
        ? dialogComponent.instance.modalDialog()
        : dialogComponent.instance.modalDialog;

    modalDialog.hidden.pipe(take(1)).subscribe(() => {
      dialogComponent.destroy();
      dialogWrapper.remove();
    });

    return dialogComponent.instance;
  }
}
